<template>
  <BasicCrud
    :fields="fields"
    :title="$t('Products')"
    path="product"
    :boolColumns="boolColumns"
    :priceColumns="priceColumns"
    :hideEditAction="!isMaster()"
    :hideDeleteAction="!isMaster()"
    :showNewButton="isMaster()"
  ></BasicCrud>
</template>

<script>

import BasicCrud from '@/components/BasicCrud'
import { mapState } from 'vuex'

export default {
  name: "Product",

  components: {
    BasicCrud
  },

  computed: mapState({
    userData: state => state.app.userData,
    fields: state => state.product.fields
  }),

  data() {
    return {
      boolColumns: ['item.vacation_season', 'item.active'],
      priceColumns: ['item.price'],
    }
  },

  methods: {
    isMaster() {
      return this.userData.roles.find(role => role == 'ROLE_MASTER') ? true : false
    }
  }
}

</script>
